module.exports = __webpack_public_path__ + "img/emoji-hi.ce788068.png";